import { createContext } from "react";
const ServiceAndCategoryContext = createContext({});
export default ServiceAndCategoryContext;
